import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";

const InProgressPopup = (props) => {

  const {useIntl, title, message} = props;

  return (
    <div className="message-loading-container">
      <div className="message-loading-left-panel message-loading-panel-settings"/>
      <div className="message-loading-right-panel message-loading-panel-settings">
        <h1>{useIntl ? <FormattedMessage id={title}/> : title}</h1>
        <p>{useIntl ? <FormattedMessage id={message}/> : message}</p>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {inProgress} = state.popups;
  return {
    title: inProgress.title,
    message: inProgress.message,
    useIntl: inProgress.useIntl,
  }
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InProgressPopup)

